import type { ReactNode } from "react";
import { Link } from "react-router";
import { buttonVariants, type ButtonVariant } from "@diametral/design-system/react";

/**
 * A router link with the look of a DS button. A real `<a>`: rendering the Base UI Button as a
 * link would give it role="button", and screen readers would announce a navigation as an action.
 */
export function ButtonLink({
  to,
  children,
  variant,
  size,
}: {
  to: string;
  children: ReactNode;
  variant?: ButtonVariant;
  size?: "sm" | "lg";
}) {
  return (
    <Link to={to} className={buttonVariants({ variant, className: `ada-button-link${size ? ` ds-button--${size}` : ""}` })}>
      {children}
    </Link>
  );
}
